var _path, _path2, _rect, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPassport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8334 16.2952V14.7841C13.8333 14.4093 14.0683 14.0747 14.4209 13.9476L15.7765 13.4596C16.2436 13.2915 16.7547 13.2915 17.2218 13.4596L18.5791 13.9485C18.9314 14.0755 19.1664 14.4096 19.1667 14.7841V16.2952C19.1667 17.4267 17.5836 18.2641 16.8556 18.5903C16.6295 18.6923 16.3705 18.6923 16.1445 18.5903C15.4165 18.2641 13.8334 17.4249 13.8334 16.2952Z",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1667 22.6667H13.8334",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.83337,
    y: 8,
    width: 21.3333,
    height: 20,
    rx: 3,
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.83337 23.5896V10.1879C5.83338 8.65188 6.78436 7.27627 8.22137 6.73366L18.5352 2.83929C19.0216 2.63941 19.5622 2.61411 20.0651 2.7677C21.1102 3.09435 21.8249 4.05852 21.8334 5.15349V7.58957",
    stroke: "#D53716",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassport);
export default __webpack_public_path__ + "static/media/passport.6bad026ddc7a1542d13cf7e8a2b9e59a.svg";
export { ForwardRef as ReactComponent };